import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { applyAccountSwitch, hasMultipleAccounts } from '../utils/accountUtils';

export function useAccountPicker(users) {
    const dispatch = useDispatch();
    const multiple = hasMultipleAccounts(users);
    const [pickerOpen, setPickerOpen] = useState(multiple);

    useEffect(() => {
        if (!multiple) {
            setPickerOpen(false);
        }
    }, [multiple]);

    const selectAccount = useCallback((user) => {
        applyAccountSwitch(dispatch, user);
        setPickerOpen(false);
    }, [dispatch]);

    const openPicker = useCallback(() => {
        if (multiple) {
            setPickerOpen(true);
        }
    }, [multiple]);

    const closePicker = useCallback(() => {
        setPickerOpen(false);
    }, []);

    return {
        multiple,
        pickerOpen,
        setPickerOpen,
        selectAccount,
        openPicker,
        closePicker,
    };
}
